import { useEffect, useState } from "react";

import api from "./api";
import { FAIXAS_RATEIO, type FaixaRateio } from "../../../shared/rateio";

/**
 * Tabela de faixas de honorários "viva" — busca a config vigente do backend
 * (que reflete os overrides do admin em /admin/config/faixas) e cai pro estático
 * `FAIXAS_RATEIO` se a chamada falhar. Use no lugar de `FAIXAS_RATEIO` direto nas
 * páginas públicas que exibem a tabela, pra ela refletir a config do admin.
 */
export function useFaixasRateio(): FaixaRateio[] {
  const [faixas, setFaixas] = useState<FaixaRateio[]>(FAIXAS_RATEIO);

  useEffect(() => {
    let vivo = true;
    api
      .tabelaHonorarios()
      .then((r) => {
        if (!vivo || !r?.faixas?.length) return;
        setFaixas(
          r.faixas.map((f) => ({
            indice: f.indice,
            rotulo: f.rotulo,
            limiteInferior: Number(f.limiteInferior),
            limiteSuperior: f.limiteSuperior == null ? null : Number(f.limiteSuperior),
            pctTotal: Number(f.pctTotal),
            pctFee: Number(f.pctFee),
            pctHonorario: Number(f.pctHonorario),
          })),
        );
      })
      .catch(() => {
        /* falha → mantém o estático (defaults do código) */
      });
    return () => {
      vivo = false;
    };
  }, []);

  return faixas;
}
